// External Imports
import { useContext, useState } from "react";
import { MdClose } from "react-icons/md";

// Internal Imports
import { requestAdminAPI } from "../../api/posh-api";
import Heading from "../UI/Heading";
import DetailPair from "../UI/DetailPair";
import Modal from "../UI/Modal";
import { constructDateObject, isoDateToString } from "../../util/format-date";
import { format } from "date-fns";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import { toTitleCase } from "../../util/format-text";
import PersonCard from "../UI/PersonCard";
import { UtilityContext } from "../../context/util-context";
import { DataContext } from "../../context/data-context";

/** ========================================================================
 * * EventModal Component
 * This component renders a form to add a maintenance log.
 * ========================================================================== */

export default function EventModal({ open, setOpen, event, onComplete }) {
  // Initialize States
  const [loading, setLoading] = useState(false);
  const { admin } = useContext(DataContext);
  const { setWarning } = useContext(UtilityContext);
  

  /* ======================= ADD MAINTENANCE ======================= */
  const deleteHandler = async () => {
    try {
      setLoading(true);
      if (admin.type !== "ADMIN" && admin.id !== event.createdById)
        throw new Error("Permission denied.");
      // Send Request
      const response = await requestAdminAPI("delete-event", {
        eventId: event.id,
      });
      onComplete(response);
      setLoading(false);
      setOpen(false);
    } catch (err) {
      console.error(err);
      setWarning(err.message);
      setLoading(false);
    }
  };

  if (event)
    return (
      <Modal open={open} setOpen={setOpen}>
        <div className="modal lg:w-[60vw]">
          <Heading title="Event Details" isBackArrow={false}>
            <MdClose className="text-2xl icon" onClick={() => setOpen(false)} />
          </Heading>
          <div className="info lg:grid-cols-3">
            <DetailPair label="Type" value={toTitleCase(event?.type)} />
            <DetailPair
              label="Start Date"
              value={format(new Date(event?.start), "MM/dd/yyyy hh:mm a")}
            />
            <DetailPair
              label="End Date"
              value={format(new Date(event?.end), "MM/dd/yyyy hh:mm a")}
            />
            <DetailPair
              label="Customer"
              value={event?.customer}
              link={
                event?.customerId && `/customers/info?id=${event?.customerId}`
              }
            />
            <DetailPair label="Customer Email" value={event?.customer_email} />
            <DetailPair label="Customer Phone" value={event?.customer_phone} />
            <DetailPair
              label="Vehicle"
              value={event?.vehicle}
              link={event?.vehicleId && `/vehicles/info?id=${event?.vehicleId}`}
            />
            <DetailPair
              label="Location"
              value={event?.address}
              link={`/locations`}
            />
            <div className="lg:col-span-2">
              <DetailPair
                label="Description"
                value={event?.description || "N/A"}
              />
            </div>
            {event?.createdById && (
              <PersonCard
                name={event?.createdByName}
                image={event?.createdByPhoto}
                label="Created By"
                secondary={isoDateToString(event?.dateCreated)}
                link={`/employees/info?id=${event?.createdById}`}
              />
            )}
            <div className="lg:col-span-3">
              {loading ? (
                <LoadingSpinnerWrapper />
              ) : (
                <div className="grid grid-cols-2 gap-4 mt-4">
                  <div className="btn-secondary" onClick={() => setOpen(false)}>
                    Close
                  </div>
                  <div onClick={deleteHandler} className="btn-warning">
                    Delete Event
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Modal>
    );
}
